import React, {FC, useEffect, useMemo, useState} from "react";
import GatewayService from "../../service/GatewayService";
import {ClientCombo} from "../../models/ClientCombo";
import {useClients} from "../../context/ClientsContext";
import {DropDownCompString, getKeyVal} from "../util/DropDownComp";
import AppUtil from "../../util/AppUtil";
import AppConstants from "../../util/AppConstants";

interface SqOffCombo {
    clientCombo: ClientCombo;
    effectiveMarginRelease: number;
}
const SqOffComponent:FC = () => {
    const [combos, setCombos] = useState<Array<SqOffCombo>>([]);
    const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
    const { clients } = useClients();
    const [client, setClient] = useState("");
    const [name, setName] = useState("");
    const [minProfit, setMinProfit] = useState(-500);
    const [minMargin, setMinMargin] = useState(0.5);
    const [days, setDays] = useState(1);

    function fetchCombos() {
        GatewayService.getSqOffCombos().then(ccs => {
            setCombos(ccs.map(clientCombo =>{
                 const effectiveMarginRelease = (clientCombo.combo.margin - clientCombo.combo.capital) * clientCombo.combo._qty;
                 return {clientCombo, effectiveMarginRelease}
            }))
        });
    }

    useEffect(() => {
        fetchCombos();
    }, []);

    const sortedCombos = useMemo(() => {
        let sortableItems = combos
            .filter(it => (client === "" || it.clientCombo.client === client))
            .filter(it => (name === "" || it.clientCombo.combo.name.toLowerCase()===(name.toLowerCase())))
            .filter(it => it.clientCombo.combo.effectiveProfit_qty >= minProfit)
            .filter(it => (it.effectiveMarginRelease) >= minMargin*100000)
            .filter(it => (it.clientCombo.combo.time/AppConstants.DAY) >= days)
        if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
                let aValue: any;
                let bValue: any;

                switch (sortConfig.key) {
                    case 'client':
                        aValue = a.clientCombo.client;
                        bValue = b.clientCombo.client;
                        break;
                    case 'margin':
                        aValue = a.effectiveMarginRelease;
                        bValue = b.effectiveMarginRelease;
                        break;
                    case 'effectiveProfit':
                        aValue = a.clientCombo.combo.effectiveProfit_qty;
                        bValue = b.clientCombo.combo.effectiveProfit_qty;
                        break;
                    default:
                        return 0;
                }

                if (aValue < bValue) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableItems;
    }, [combos, sortConfig, client, name, minProfit, minMargin, days]);

    const requestSort = (key: string) => {
        let direction: 'ascending' | 'descending' = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    function placeOrder(clientCombo: ClientCombo) {
        clientCombo.combo.noMargin = true
        GatewayService.exec(clientCombo.combo, clientCombo.client)
    }

    return <div>
        <h1>Square Off Combos</h1>
        <div className={"filter"}>
        <DropDownCompString text={"select client"} actual={client} arr={getKeyVal(clients)} set={setClient}/>
        <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Filter by name"/>
        <input type="number" value={minProfit} onChange={e => setMinProfit(Number(e.target.value))} placeholder="Min profit"/>
        <input type="number" value={minMargin} onChange={e => setMinMargin(Number(e.target.value))} placeholder="Min margin"/>
        <input type="number" value={days} onChange={e => setDays(Number(e.target.value))} placeholder="Days"/>
        <button onClick={() => fetchCombos()}>Refresh</button>
        </div>
        <table>
            <thead>
            <tr>
                <th onClick={() => requestSort('client')}>Client</th>
                <th>name</th>
                <th>days</th>
                <th onClick={() => requestSort('symbols')}>Symbols</th>
                <th onClick={() => requestSort('margin')}>Margin</th>
                <th onClick={() => requestSort('effectiveProfit')}>Effective Profit</th>
                <th>Exec</th>
            </tr>
            </thead>
            <tbody>
            {sortedCombos.map((clientCombo, index) => (
                <tr key={index}>
                    <td>{clientCombo.clientCombo.client}</td>
                    <td>{clientCombo.clientCombo.combo.name}</td>
                    <td>{(clientCombo.clientCombo.combo.time/AppConstants.DAY).toFixed()}</td>
                    <td>{AppUtil.getSymbols(clientCombo.clientCombo.combo)}</td>
                    <td>{AppUtil.getLacks(clientCombo.effectiveMarginRelease)}</td>
                    <td>{AppUtil.getRoundedOff(clientCombo.clientCombo.combo.effectiveProfit_qty)}</td>
                    <td><button onClick={()=>placeOrder(clientCombo.clientCombo)}>exec</button></td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>
}

export default SqOffComponent;
